import axios_instance from './liveChatAxiosInst';

async function setCommunicationIsClose (
        state,
        dispatch,
    ) {
    await axios_instance.post(
        process.env.REACT_APP_LIVE_CHAT_API,
        {
            action: "setCommunicationIsClose",
            chat_id: state.active_communication[0].chat_id,
            status: 'resolu',
            session_pseudo: state.pseudo,
        },
    )
    .then ((resp) => {
        if (resp.status === 200) {
            dispatch({
                type: 'change_active_communication',
                payload: {active_communication: []}
            });
        } else {
            dispatch({
                type: 'change_active_communication',
                payload: {active_communication: []}
            });
        }
    })
    .catch (() => 
        dispatch({
            type: 'change_active_communication',
            payload: {active_communication: []}
        })
    )
}

export default setCommunicationIsClose;